<form #formRef="ngForm">
	<bb-page-header [icon]="'user'" [title]="'ACCOUNT_SETTINGS' | translate">
		<ul class="tabs">
			<li>
				<a class="active">
					<i class="fa fa-cog"></i> {{ 'USER_INFO' | translate }}
				</a>
			</li>
		</ul>
	</bb-page-header>

	<div class="body-column">
		<bb-form-element class="left-align" [form]="form" invalidMessage="'USER_INFO_FIRSTNAME_IS_REQUIRED' | translate"
			[label]="'FIRST_NAME' | translate">
			<input [(ngModel)]="firstName" type="text" name="firstName" required/>
		</bb-form-element>

		<bb-form-element class="left-align" [form]="form" invalidMessage="'USER_INFO_LASTNAME_IS_REQUIRED' | translate"
			[label]="'LAST_NAME' | translate">
			<input [(ngModel)]="lastName" type="text" name="lastName" required/>
		</bb-form-element>

		<bb-form-element class="left-align" [form]="form" invalidMessage="USER_INFO_EMAIL_IS_REQUIRED' | translate"
			[label]="'EMAIL_ADDRESS' | translate">
			<input [(ngModel)]="email" type="email" name="email" required/>
		</bb-form-element>

		<bb-form-element class="left-align" [label]="'PASSWORD' | translate">
			<div *ngIf="!changePassword">
				<a class="button" (click)="changePassword = true">{{ 'CHANGE_PASSWORD' | translate }}</a>
			</div>
			<div class="change-password" *ngIf="changePassword">

				<bb-form-element class="left-align" [form]="form"
					invalidMessage="'USER_INFO_NEW_PASSWORD_IS_REQUIRED' | translate"
					[label]="'PASSWORD_NEW' | translate">
					<input [(ngModel)]="newPassword" type="password" name="newPassword" required/>
				</bb-form-element>

				<bb-form-element class="left-align" [form]="form"
					invalidMessage="'USER_INFO_NEW_PASSWORD_AGAIN_IS_REQUIRED | translate"
					[label]="'PASSWORD_NEW_AGAIN' | translate">
					<input [(ngModel)]="newPasswordAgain" type="password" name="newPasswordAgain" required/>
				</bb-form-element>

				<small>{{ 'CHANGE_PASSWORD_REQUIREMENTS' | translate }}</small>

			</div>
		</bb-form-element>

		<hr />

		<p>{{ 'USER_INFO_OLD_PASSWORD' | translate }}</p>

		<bb-form-element class="left-align" [form]="form" invalidMessage="'USER_INFO_PASSWORD_IS_REQUIRED' | translate"
			[label]="'PASSWORD_OLD' | translate">
			<input [(ngModel)]="oldPassword" type="password" name="oldPassword" required/>
		</bb-form-element>

	</div>

</form>

<bb-actions-bar (onSave)="save($event)" (onCancel)="cancel()" [form]="form" [entity]="entity"></bb-actions-bar>
